// extracted by mini-css-extract-plugin
export default {"table":"SearchMain_table__9uakk","logoTick":"SearchMain_logoTick__tpH5L"};